export default "__VITE_ASSET__BPcYrvWB__"